module.exports = __webpack_public_path__ + "static/3_protection-2d75c1ffa5621ad17d7bddc782eedff1.png";